<ion-header class="modal-header">
  <ion-toolbar>
    <div class="title-container">
      <div class="title">
        {{
          (config && config.title ? config.title : "contracts.sign_contract")
            | translate
        }}
      </div>
      <div class="close" (click)="close()">
        <ion-icon name="dp-close"></ion-icon>
      </div>
    </div>
  </ion-toolbar>
</ion-header>

<div class="modal-content">
  <div class="container" *ngIf="config && config.contract">
    <div class="contract-card">
      <div class="contract-header">
        <h3 class="contract-type">
          {{
            getContractTypeLabel(config.contract ? config.contract.type : null)
          }}
        </h3>
        <div class="contract-meta" *ngIf="config.contract.version">
          <span class="contract-version">
            {{ "contracts.version" | translate }}: {{ config.contract.version }}
          </span>
        </div>
      </div>

      <div class="signature-section">
        <div class="signature-label">
          {{ "contracts.signature" | translate }}
        </div>
        <div class="canvas-container">
          <canvas #signatureCanvas class="signature-canvas"></canvas>
        </div>
        <ion-button
          fill="outline"
          size="small"
          (click)="clearSignature()"
          class="clear-button"
        >
          <ion-icon name="refresh-outline" slot="start"></ion-icon>
          {{ "contracts.clear_signature" | translate }}
        </ion-button>
      </div>
    </div>
  </div>
</div>

<ion-footer class="modal-footer">
  <ion-toolbar>
    <div class="footer-buttons">
      <ion-button fill="outline" (click)="close()" class="cancel-button">
        {{ "general.cancel" | translate }}
      </ion-button>
      <ion-button (click)="sign()" class="sign-button">
        {{ "contracts.sign" | translate }}
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
